import { Attribute } from '@app/components/various/AttributesList/Attribute';
import { Skeleton } from '@app/components/various/Skeleton';
import { AccountRequestStatus } from '@app/constants/requests';
import { useAccountRequestStatusLabel } from '@app/utils/hooks/useAccountRequestStatusCell';
import { isDefined } from '@app/utils/is';
import { useTranslation } from 'react-i18next';

import { RequestStatus } from '../../components/various/RequestStatus';

interface Props {
  isLoading?: boolean;
  status?: AccountRequestStatus;
  createdAt: string;
}

export const AccountRequestStatusBar = ({ createdAt, status, isLoading }: Props) => {
  const { t } = useTranslation(['requests']);
  const { getStatusLabel } = useAccountRequestStatusLabel();

  if (isLoading || !isDefined(status)) {
    return (
      <div className="flex flex-wrap items-center gap-x-10 gap-y-3 lg:gap-x-36">
        <Attribute name={t('requests:request_status')} value={<Skeleton type="rectangle" className="h-6 w-24" />} orientation="vertical" />
        <Attribute name={t('requests:requested')} value={<Skeleton type="rectangle" className="h-6 w-24" />} orientation="vertical" />
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-x-10 gap-y-3 lg:gap-x-36">
      <Attribute
        name={t('requests:request_status')}
        value={
          <span className="flex items-center gap-1">
            <RequestStatus type={status} />
            <span className="text-neutral-20">{getStatusLabel(status)}</span>
          </span>
        }
        orientation="vertical"
      />
      <Attribute name={t('requests:requested')} value={createdAt} orientation="vertical" />
    </div>
  );
};
